// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AOrder } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function useOrderResource () {

    /**
     * Retrieves a list of submitted orders for the current web account.
     * @param orderTypeId (optional) 
     * @param filterByShowInHistory (optional) 
     * @return A task that represents the asynchronous operation, containing an action result with a list of submitted orders for the current web account, or a forbidden result if the web account ID is not available.
     */
    function listSubmittedOrdersForWebAccount(
        orderTypeId?: MaybeRef<number | null | undefined>,
        filterByShowInHistory?: MaybeRef<boolean | undefined>
    ) : UseApiFetchResponse<AOrder[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/Order/web-account?";

        const orderTypeIdUnref = unref( orderTypeId );
        if (orderTypeIdUnref !== undefined && orderTypeIdUnref !== null)
            url_ += "orderTypeId=" + encodeURIComponent("" + orderTypeIdUnref) + "&";
        const filterByShowInHistoryUnref = unref( filterByShowInHistory );
        if (filterByShowInHistoryUnref === null)
            throw new Error("The parameter 'filterByShowInHistory' cannot be null.");
        else if (filterByShowInHistoryUnref !== undefined)
            url_ += "filterByShowInHistory=" + encodeURIComponent("" + filterByShowInHistoryUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<AOrder[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<AOrder[]>( computedUrl, options_ );
    }

    /**
     * Retrieves a list of submitted orders for the organization associated with the current web account.
    The integer id code for retrieving specific order types (e.g. wishlist).
     Whether to only include results with the showInHistory flag enabled.
     * @param orderTypeId (optional) 
     * @param filterByShowInHistory (optional) 
     * @return A task that represents the asynchronous operation. The task result contains a list of submitted orders for the organization.
     */
    function listSubmittedOrdersForOrg(
        orderTypeId?: MaybeRef<number | null | undefined>,
        filterByShowInHistory?: MaybeRef<boolean | undefined>
    ) : UseApiFetchResponse<AOrder[]> {
        const computedUrl = computed( () => {
          let url_ = "/api/Order/org?";

        const orderTypeIdUnref = unref( orderTypeId );
        if (orderTypeIdUnref !== undefined && orderTypeIdUnref !== null)
            url_ += "orderTypeId=" + encodeURIComponent("" + orderTypeIdUnref) + "&";
        const filterByShowInHistoryUnref = unref( filterByShowInHistory );
        if (filterByShowInHistoryUnref === null)
            throw new Error("The parameter 'filterByShowInHistory' cannot be null.");
        else if (filterByShowInHistoryUnref !== undefined)
            url_ += "filterByShowInHistory=" + encodeURIComponent("" + filterByShowInHistoryUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<AOrder[]> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<AOrder[]>( computedUrl, options_ );
    }

    return {
        listSubmittedOrdersForWebAccount,
        listSubmittedOrdersForOrg,
    }
}


export function $orderResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Retrieves a list of submitted orders for the current web account.
     * @param orderTypeId (optional) 
     * @param filterByShowInHistory (optional) 
     * @return A task that represents the asynchronous operation, containing an action result with a list of submitted orders for the current web account, or a forbidden result if the web account ID is not available.
     */
    function listSubmittedOrdersForWebAccount(
        orderTypeId?: number | null | undefined,
        filterByShowInHistory?: boolean | undefined
    ) {
        let url_ = "/api/Order/web-account?";

        const orderTypeIdUnref = unref( orderTypeId );
        if (orderTypeIdUnref !== undefined && orderTypeIdUnref !== null)
            url_ += "orderTypeId=" + encodeURIComponent("" + orderTypeIdUnref) + "&";
        const filterByShowInHistoryUnref = unref( filterByShowInHistory );
        if (filterByShowInHistoryUnref === null)
            throw new Error("The parameter 'filterByShowInHistory' cannot be null.");
        else if (filterByShowInHistoryUnref !== undefined)
            url_ += "filterByShowInHistory=" + encodeURIComponent("" + filterByShowInHistoryUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<AOrder[]>( url_, options_, dependencies_ );
    }

    /**
     * Retrieves a list of submitted orders for the organization associated with the current web account.
    The integer id code for retrieving specific order types (e.g. wishlist).
     Whether to only include results with the showInHistory flag enabled.
     * @param orderTypeId (optional) 
     * @param filterByShowInHistory (optional) 
     * @return A task that represents the asynchronous operation. The task result contains a list of submitted orders for the organization.
     */
    function listSubmittedOrdersForOrg(
        orderTypeId?: number | null | undefined,
        filterByShowInHistory?: boolean | undefined
    ) {
        let url_ = "/api/Order/org?";

        const orderTypeIdUnref = unref( orderTypeId );
        if (orderTypeIdUnref !== undefined && orderTypeIdUnref !== null)
            url_ += "orderTypeId=" + encodeURIComponent("" + orderTypeIdUnref) + "&";
        const filterByShowInHistoryUnref = unref( filterByShowInHistory );
        if (filterByShowInHistoryUnref === null)
            throw new Error("The parameter 'filterByShowInHistory' cannot be null.");
        else if (filterByShowInHistoryUnref !== undefined)
            url_ += "filterByShowInHistory=" + encodeURIComponent("" + filterByShowInHistoryUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<AOrder[]>( url_, options_, dependencies_ );
    }

    return {
        listSubmittedOrdersForWebAccount,
        listSubmittedOrdersForOrg,
    }
}